import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

const appendIfValue = (formData, key, value) => {
  if (value === undefined || value === null || value === '') return;
  formData.append(key, value);
};

const buildKonfirmasiFormData = (payload = {}) => {
  const formData = new FormData();

  appendIfValue(formData, 'id_transaksi', payload.id_transaksi);
  appendIfValue(formData, 'id_transaksi_kurban', payload.id_transaksi_kurban);
  appendIfValue(formData, 'foto_bukti', payload.foto_bukti);
  appendIfValue(formData, 'status', payload.status);

  if (payload.foto_konfirmasi instanceof File) {
    formData.append('foto_konfirmasi', payload.foto_konfirmasi);
  } else {
    appendIfValue(formData, 'foto_konfirmasi', payload.foto_konfirmasi);
  }

  return formData;
};

const getErrorMessage = (err, fallback) =>
  err.response?.data?.detail ||
  err.response?.data?.error ||
  err.response?.data?.message ||
  err.message ||
  fallback;

const useKonfirmasiTransaksiCRUD = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getKonfirmasiTransaksi = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get(endpoints.konfirmasi_transaksi.getById(id));
      return response.data;
    } catch (err) {
      const message = getErrorMessage(err, 'Terjadi kesalahan saat mengambil konfirmasi transaksi.');
      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };

  const postKonfirmasiTransaksi = async (payload) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.post(
        endpoints.konfirmasi_transaksi.create,
        buildKonfirmasiFormData(payload),
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      return response.data;
    } catch (err) {
      const message = getErrorMessage(err, 'Terjadi kesalahan saat membuat konfirmasi transaksi.');
      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };

  const putKonfirmasiTransaksi = async (id, payload) => {
    setLoading(true);
    setError(null);

    try {
      const data = buildKonfirmasiFormData(payload);
      const response = await api.put(endpoints.konfirmasi_transaksi.update(id), data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (err) {
      if (err.response?.status === 405 || err.response?.status === 404) {
        try {
          const fallbackData = buildKonfirmasiFormData(payload);
          fallbackData.append('_method', 'PUT');
          const fallbackResponse = await api.post(endpoints.konfirmasi_transaksi.update(id), fallbackData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          return fallbackResponse.data;
        } catch (fallbackErr) {
          const message = getErrorMessage(fallbackErr, 'Terjadi kesalahan saat memperbarui konfirmasi transaksi.');
          setError(message);
          throw new Error(message);
        }
      }

      const message = getErrorMessage(err, 'Terjadi kesalahan saat memperbarui konfirmasi transaksi.');
      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };

  const deleteKonfirmasiTransaksi = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.delete(endpoints.konfirmasi_transaksi.delete(id));
      return response.status === 200 || response.status === 204;
    } catch (err) {
      const message = getErrorMessage(err, 'Terjadi kesalahan saat menghapus konfirmasi transaksi.');
      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };

  return {
    getKonfirmasiTransaksi,
    postKonfirmasiTransaksi,
    putKonfirmasiTransaksi,
    deleteKonfirmasiTransaksi,
    loading,
    error,
  };
};

export default useKonfirmasiTransaksiCRUD;
